module.exports = "<div>\n  <button class=\"btn-bg-{{color}}\">btn-bg-{{color}}</button>\n  <button class=\"btn-bd-{{color}}\">btn-bd-{{color}}</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_buttons_colors.html
// module id = 95
// module chunks = 0